export default {
  "home": {
    "minute": "นาที",
    "price_info": "เช่าฟรี {mianfei} นาทีแรก ค่าเช่าสูงสุดใน 24 ชม. คือ {fengding} บาท สามารถคืนพาวเวอร์แบงก์ได้ทุกที่ที่มีเครื่องชาร์จของ {appName}",
    "price_info_0": "มีสายชาร์จหัว Type C และ Lightning ในตัว",
    "price_info_1": "หากไม่มีการคืนพาวเวอร์แบงก์ภายใน {pOvertimeDay} วัน จะถูกยึดมัดจำ (490 บาท)",
    "price_info_2": "สแกนคิวอาร์ดค้ดหรือโหลดแอปพลิเคชั่น Mother Charger เพื่อหาตำแหน่งเครื่องชาร์จ",
    "feature_1": "รองรับสายชาร์จหัว Type C และ Lightning",
    "feature_2": "สามารถคืนได้ทุกเครื่องชาร์จของ Mother Charger",
    "feature_3": "รองรับการชาร์จแบบไร้สาย",
    "tips_1": "จะได้รับเงินมัดจำคืนเมื่อพาวเวอร์แบงก์ถูกนำไปคืน",
    "tips_2": "ใน Wallet สามารถเติมเงินเพื่อใช้เช่าพาวเวอร์แบงก์ได้ และสามารถถอนออกได้ทุกเมื่อ",
    "tips_3": "ยอดเงินใน Wallet สามารถใช้ในการเช่าพาวเวอร์แบงก์ได้",
    "submit": "ยืนยัน",
    "borrow": "เช่า",
    "msg_fail_title": "ผิดพลาด",
    "msg_fail_content": "การยืมไม่สำเร็จ โปรดลองใหม่อีกครั้ง",
    "msg_rentcount": "ขณะนี้คุณยังมีพาวเวอร์แบงก์ที่ไม่ได้ถูกนำไปคืน",
    "goborrow": "เริ่มชาร์จได้!!",
    "nearby": "ดูเครื่องชาร์จใกล้ฉัน",
    "preauth": "การกันวงเงิน",
    "nearbyvenues": "ค้นหาเครื่องชาร์จใกล้ฉัน",
    "borrow_tips": "",
    "typec": "Type-C",
    "micro": "Micro",
    "ios": "Lightning",
    "fastcharge": "การชาร์จเร็ว",
    "max": "สูงสุด",
    "per_day": "ต่อวัน",
    "next": "ต่อไป",
    "welcome": "ยินดีต้อนรับสู่"
  },
  "borrow": {
    "unlock_power_bank": "ปลดล็อกพาวเวอร์แบงก์",
    "other_options": "อื่นๆ",
    "select_payment": "เลือกการชำระเงิน",
    "payment_method": "รายละเอียดการชำระเงิน",
    "coupon_code": "คูปอง และรหัส",
    "pre_authorisation": "การกันวงเงิน",
    "per": "ต่อ",
    "all_pricing": "เกี่ยวกับราคา",
    "max": "เต็ม",
    "per_day": "ต่อวัน",
    "next": "ต่อไป",
    "login_tips": "กรุณาเข้าสู่ระบบ"
  },
  "preauth": {
    "title": "เกี่ยวกับการกันวงเงิน",
    "tips1": "เมื่อมีการเช่าพาวเวอร์แบงก์ ระบบจะทำการกันวงเงิน เพื่อให้แน่ใจว่ามีเงินเพียงพอสำหรับการชำระค่าเช่า",
    "tips2": "ธนาคารอาจมีการส่งแจ้งเตือนเรื่องการกันวงเงิน (แต่ไม่ใช่การหักเงิน) เงินจะถูกหักเฉพาะค่าเช่าเท่านั้น",
    "tips3": "การแจ้งยอดคืนบัญชีจากการกันวงเงิน อาจใช้เวลาตั้งแต่ไม่ถึงชั่วโมง ถึงวัน"
  },
  "rentcost": {
    "rentcosttitle": "ราคาในการเช่าคิดเท่าไหร่?",
    "price1": "{currency} {jifei} ต่อ {jifeiDanwei} {priceUnit}",
    "price2": "{currency} {fengding} ต่อวัน",
    "tip1": "หากไม่มีการคืนพาวเวอร์แบงก์ภายใน {overtime} วัน จะถูกยึดมัดจำ ({overtimeAmount} บาท)",
    "tip2": "ระยะเวลาที่เกินจะเป็นการปัดเศษ",
    "tip3": "การเช่าแบบเหมาวันเวลาตั้งแต่การเช่าไปอีก 24 ชม.",
    "tip4": "บางสถานที่ในการเช่าพาวเวอร์แบงก์อาจจะมีโปรโมชั่นหรือโค้ดลดพิเศษ",
    "Days": "วัน",
    "Hours": "ชั่วโมง",
    "Minutes": "นาที",
    "free": "ฟรี {mianfei} นาทีแรก",
    "willcharged": "คุณจะถูกเรียกเก็บเงินจำนวน {currency} {money}"
  },
  "login": {
    "welcome": "ยินดีตอนรับสู่ Mother Charger",
    "code_title": "ยืนยันตัวตน",
    "phone": "เบอร์",
    "phone_number": "เบอร์โทร",
    "verification_email": "โปรดใส่อีเมล",
    "verification_code": "โปรดใส่รหัสยืนยัน",
    "captcha_code": "รหัส",
    "send_code": "ส่งรหัส",
    "login": "เข้าสู่ระบบ",
    "agree": "ตกลงในการเข้าสู่ระบบ",
    "readme": "ยอมรับ",
    "msg_fail_login": "เข้าสู่ระบบไม่สำเร็จ",
    "msg_success_login": "เข้าสู่ระบบสำเร็จ",
    "msg_fail_user": "มีความผิดพลาดในการโหลดข้อมูลของผู้ใช้ โปรดลองใหม่อีกครั้ง",
    "sign_in_with": "เข้าสู่ระบบด้วย",
    "no_sms": "ไม่ได้รับข้อความ",
    "retry": "ส่งใหม่",
    "email": "อีเมล"
  },
  "confirm": {
    "deletecard": "ลบบัตร",
    "addcard": "โปรดใส่ข้อมูลบัตร",
    "title": "ยืนยันการชำระเงิน",
    "paynow": "ชำระเงินทันที",
    "SMSConfirm": "โปรดชำระเงิน และกดปุ่มยืนยันเพื่อทำรายการต่อ",
    "pay_label": "รวม",
    "auth_label": "การกันวงเงิน",
    "price_tips": "กรุณาชำระเงิน และสามารถถอนเงินออกได้ทุกเมื่อ แต่อาจใช้เวลา 1-5 วันในการคืน",
    "auth_tips": "จะมีการกันวงเงินเป็นค่ามัดจำ จำนวน 490 บาท และค่าเช่าจะถูกหักไปตามจริง หลังจากทำการคืนพาวเวอร์แบงก์",
    "pay_type": "กรุณาเลือกช่องทางการชำระเงิน",
    "submit": "ยืนยันการชำระเงิน",
    "msg_loading": "กำลังโหลด",
    "msg_fail_title": "คำเตือน",
    "msg_fail_payment": "ไม่สามารถเติมเงินได้",
    "msg_fail_order": "ไม่สามารถเติมเงินได้",
    "msg_fail_support": "ระบบ",
    "msg_fail_confirm": "ตกลง",
    "msg_fail_retry": "ลองใหม่",
    "msg_fail_cancel": "ยกเลิก"
  },
  "mine": {
    "title": "โปรไฟล์",
    "wallet": "Wallet",
    "balance": "ยอดเงินคงเหลือ",
    "deposit": "มัดจำ",
    "wallet_in": "ค่าใช้จ่าย",
    "wallet_out": "ถอนเงิน",
    "wallet_log": "ประวัติการ้งาน Log",
    "rental_history": "ประวัติการเช่า",
    "payment_title": "วิธีการชำระเงิน",
    "download_app": "โหลดแอปพลิเคชั่น",
    "settings": "ตั้งค่า",
    "help": "ช่วยหลือ",
    "logout": "ออกจากระบบ",
    "login_tips": "กรุณาเข้าสู่ระบบ",
    "msg_fail_title": "ผิดพลาด",
    "msg_fail_update": "การแก้ไขล้มเหลว โปรดลองอีกครั้ง",
    "msg_loading": "กำลังโหลด",
    "msg_fail_user": "มีความผิดพลาดในการโหลดข้อมูลของผู้ใช้ โปรดลองใหม่อีกครั้ง",
    "edit_profile": "แก้ไขโปรไฟล์",
    "join_us": "เข้าร่วม",
    "join_us_details": "หาเครื่องชาร์จใกล้ฉัน"
  },
  "msg": {
    "appoffline": "แอปพลิเคชั่นนี้ยังไม่ถูกใช้งาน โปรดรอ",
    "deletecard": "คุณแน่ใจว่าต้องการลบบัตรนี้?",
    "no_phone": "กรุณาใส่หมายเลขโทรศัพท์",
    "loading": "กำลังโหลด",
    "title": "คำอธิบาย",
    "success": "ดำเนินการสำเร็จ",
    "error": "ผิดพลาด กรุณาลองอีกครั้ง",
    "roleerror": "สิทธิ์การเข้าถึงไม่เพียงพอ กรุณาติดต่อเจ้าหน้าที่",
    "neterror": "การเชื่อมต่อเครือข่ายล้มเหลว กรุณาลองใหม่อีกครั้ง",
    "confirm": "ตกลง",
    "retry": "ลองใหม่",
    "cancel": "ยกเลิก",
    "title_fail": "คำเตือน",
    "vieworder": "ดูคำสั่งซื้อ",
    "success_payment": "การชำระเงินสำเร็จ",
    "success_buy": "คำสั่งซื้อสำเร็จ",
    "fail_payment": "การชำระเงินไม่สำเร็จ",
    "keyword": "Keyword",
    "ispayorder": "กรุณากดยืนยันหลังชำระเงิน",
    "unpay": "ยังไม่ได้ชำระ",
    "yespay": "จ่ายเงิน",
    "notopen": "ยังไม่ได้เปิด"
  },
  "result": {
    "tips": "หากต้องการดูคำสั่งซื้อ และสถานที่ กรุณาโหลดแอปพลิเคชั่น",
    "download": "โหลดแอปพลิเคชั่น",
    "title": "ยืนยันการเช่า",
    "gotit": "เข้าใจ",
    "price_plan": "การชาร์จพื้นฐาน",
    "msg_success": "การเช่าสำเร็จ",
    "msg_tips_loading": "พาวเวอร์แบงก์กำลังเชื่อมต่อ กรุณารอสักครู่",
    "msg_result_loading": "กำลังตรวจสอบการชำระเงิน",
    "msg_fail_confirm": "ยืนยัน",
    "btn_usage": "หมายเหตุการใช้งาน",
    "btn_return": "บันทึกการคืน",
    "deposit": "มัดจำ",
    "msg_fail_content": "คำขอไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "price_label": "ต่อชั่วโมง",
    "price_info": "ใช้งานฟรี 2 นาทีแรก สูงสุด 120 บาทต่อวัน เงินมัดจำจะถูกหักออกไปอัตโนมัติเมื่อตามราคาเช่า",
    "tips_1": "โปรดหยิบพาวเวอร์แบงก์ตามหมายเลข ...",
    "tips_2": "จัดเก็บสายชาร์จให้เรียบร้อย และนำพาวเวอร์แบงก์ใส่คืนที่ช่องที่มีลูกศรชี้ลง",
    "msg_note_usage": "พาวเวอร์แบงก์มาพร้อมสายชาร์จ 2 หัว",
    "msg_note_return": "จัดเก็บสายชาร์จให้เรียบร้อย และนำพาวเวอร์แบงก์ใส่คืนที่ช่องที่มีลูกศรชี้ลง",
    "return_info": "โปรดเก็บสายชาร์จให้เรียบร้อย และนำพาวเวอร์แบงก์เสียบกลับเข้าเครื่องชาร์จ โดยนำฝั่งชิปหันเข้าแล้วเสียงเข้าไปจนสนิทให้แน่นสนิท",
    "download_tips": "ในการเช่าพาวเวอร์แบงก์ โปรดเลือกวิธีที่ต้องการ",
    "rental_success": "การเช่าสำเร็จ"
  },
  "result_msg": {
    "loading": "กำลังโหลด",
    "refresh": "โหลดใหม่"
  },
  "order": {
    "title": "ประวัติการเช่า",
    "in_use": "ถูกใช้งาน",
    "ended": "เสร็จสิ้น",
    "msg_error": "คำขอล้มเหลว",
    "order_number": "หมายเลขบัตร",
    "order_details": "คำสั่งซื้อ",
    "order_zj_shop": "สถานที่เช่า",
    "order_zj_time": "เวลาเริ่มเช่า",
    "order_gh_shop": "สถานที่คืน",
    "order_gh_time": "เวลาที่คืน",
    "order_use_time": "เวลาเช่า",
    "order_amount": "รวม",
    "not_on_rent": "ไม่พร้อมใช้งาน",
    "renting": "ในการเช่า ",
    "undone": "ยังไม่สำเร็จ",
    "returned": "คืนแล้ว",
    "questions": "คำถาม",
    "timeout_to_return": "หมดเวลาคืน",
    "suspended_for_billing": "ระงับการเก็บเงิน"
  },
  "order_item": {
    "order_number": "หมายเลข ",
    "venue_rented": "สถานที่เช่า",
    "time_rented": "เวลาในการเช่า",
    "venue_returned": "สถานที่คืน",
    "time_returned": "เวลาคืน",
    "charge_standard": "มาตราฐานการชาร์จ",
    "charge_standard_info": "1 บาท ต่อ 1 นาที",
    "rent_occurred": "การเช่า",
    "returned": "คืนแล้ว",
    "unreturned": "ไม่ถูกคืน",
    "type_0": "ยังไม่เสร็จสิ้น",
    "type_1": "กำลังเช่า",
    "type_2": "ยกเลิกแล้ว",
    "type_3": "ยกเลิกแล้ว",
    "type_4": "เกิดข้อผิดพลาด",
    "type_5": "เกินเวลา",
    "min": "นาที",
    "payment": "ชำระเงิน",
    "unpay": "ยังไม่ได้ชำระเงิน"
  },
  "setting": {
    "title": "ตั้งค่า",
    "lang": "ภาษา"
  },
  "help": {
    "title": "FAQ",
    "rentals": "การเช่า",
    "venues": "สถานที่",
    "payments": "ชำระเงิน"
  },
  "wallet_in": {
    "title": "ยอดเงินจากการเติมเงิน",
    "price_label": "จำนวนการเติมเงิน",
    "price_placeholder": "โปรดระบุจำนวนเงิน",
    "balance": "ยอดเงินคงเหลือ",
    "price_auto": "เลือกวิธีการชำระเงิน",
    "price_tips": "คุณสามารถถอนเงินจากยอดคงเหลือได้ อาจใช้เวลา 1-5 วัน",
    "submit": "ส่ง",
    "loading": "กำลังโหลด",
    "paying": "กำลังไปหน้าชำระเงิน",
    "msg_title": "ข้อความ",
    "msg_fail_order": "การเช่าล้มมเหลว",
    "msg_fail_payment": "การเติมเงินล้มเหลว",
    "msg_fail_retry": "ลองใหม่"
  },
  "wallet_out": {
    "title": "การถอนเงิน",
    "price_label": "จำนวนเงินที่ถอน",
    "price_placeholder": "โปรดระบุจำนวนเงินที่ต้องการถอน",
    "balance": "ยอดเงินคงเหลือ",
    "balance_all": "ถอนเงิน",
    "deposit": "เงินมัดจำ",
    "deposit_tips": "พาวเวอร์แบงก์ยังถูกเช่าอยู่ ยังไม่สามารถคืนเงินมัดจำได้",
    "submit": "ส่ง",
    "apply": "ตกลง",
    "confirm": "ตกลง",
    "loading": "กำลังโหลด",
    "msg_fail_price": "จำนวนเงินในการถอนไม่ถูกต้อง",
    "msg_fail_balance": "จำนวนเงินในการถอนต้องเพียงพอกับยอดเงินที่มี",
    "msg_fail_submit": "กรุณาใส่ข้อมูลให้ครบ",
    "msg_title": "ผิดพลาด",
    "msg_success_content": "การคืนเงินสำเร็จ",
    "confirmtitle": "ข้อความ",
    "confirmcontent": "หากต้องการถอนเงินจาก Wallet กรุณากรอกข้อมูลบัญชีธนาคาร",
    "payee_name": "ชื่อบนบัตร",
    "payee_bankcard": "หมายเลขบัตร",
    "payee_phone": "โทร",
    "cancelText": "ยกเลิก",
    "confirmText": "ลองอีกครั้ง"
  },
  "map": {
    "在线": "เปิด",
    "离线": "ปิด",
    "title": "เครื่องชาร์จใกล้ฉัน",
    "result_msg": "ไม่มีเครื่องชาร์จใกล้คุณ",
    "msg_title": "ผิดพลาด",
    "no_support": "ขออภัย! ระบบของคุณไม่รองรับการค้นหาสถานที่",
    "my_position": "ตำแหน่งปัจจุบัน",
    "distance": "ระยะทาง",
    "shop_time": "ชั่วโมง",
    "free": "เครื่องว่างให้เช่า",
    "return": "ช่องว่างให้คืน",
    "shop_title": "ข้อมูลสถานที่",
    "address": "ที่อยู่",
    "go_here": "ไปที่นี่",
    "nav_help": "ช่วยเหลือ",
    "nav_search": "ค้นหา",
    "locate": "ที่ตั้ง"
  },
  "scanQr": {
    "NotAllowedError": "ขออนุญาตการเข้าถึงกล้อง",
    "NotFoundError": "ไม่สามารถใช้งานกล้องได้",
    "NotSupportedError": "ต้องการเข้าถึงข้อมูลความปลอดภัย",
    "NotReadableError": "กำลังใช้งานกล้อง",
    "OverconstrainedError": "ตำแหน่งกล้องไม่ถูกต้อง",
    "StreamApiNotSupportedError": "ยังไม่รองรับการทำงาน"
  },
  "payment": {
    "payment_title": "วิธีการชำระเงิน",
    "pay_type": "โปรดใส่ข้อมูลบัตร",
    "add_payment_card": "เพิ่มบัตร",
    "add_payment": "เพิ่มวิธีการชำระเงิน"
  },
  "shop": {
    "title": "เครื่องชาร์จใกล้ฉัน",
    "search_station": "ค้นเครื่องชาร์จ",
    "search_station_tips": "โปรดใส่ชื่อสาขา",
    "shop_power_banks": "พาวเวอร์แบงก์",
    "shop_empty_slots": "ช่องว่าง",
    "shop_address": "ที่อยู่",
    "shop_business_hours": "เวลาทำการ",
    "shop_directions_station": "เส้นทางไปยังเครื่องชาร์จ",
    "shop_scan_qrcode": "สแกนคิวอาร์โค้ด"
  },
  "time": {
    "days": "วัน",
    "hours": "ชั่วโมง",
    "minutes": "นาที"
  }
};
